import {useEffect, useRef} from "react";

export const useInfiniteScroll = (
    onLoadMore: (() => void) | undefined,
    {enabled = true, rootMargin = "200px"} = {}
) => {
    const sentinelRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const el = sentinelRef.current;
        if (!el || !enabled || !onLoadMore) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) onLoadMore();
            },
            {rootMargin}   // start fetching 200px before the sentinel is visible
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [onLoadMore, enabled, rootMargin]);

    return sentinelRef;
};